import type { User } from '@snapptinc/fraud-platform';
import { invitationApi } from 'src/api';
import { unauthenticatedSessionInstance } from 'src/api/instance';
import { configVars } from 'src/helpers';
import { getPaginationRequest, IInvitation, IInvitationRequest } from 'src/ts/interfaces';

const api = {
  getAll: async ({ page, rowsPerPage, filter, sort, q }: getPaginationRequest) => {
    // TODO: page and rowsPerPage should comes as number
    const pageNum = page?.toString();
    const rowsPerPageNum = rowsPerPage?.toString();
    return await invitationApi.getInvitations(pageNum, rowsPerPageNum, filter, sort, q);
  },
  delete: async (invitationId: string) => {
    // TODO: Should return something
    return await invitationApi.deleteInvitation(invitationId);
  },
  resendInvitation: async (invitationId: string) => {
    // TODO: Should return something
    return await invitationApi.resendInvitation(invitationId);
  },
  getById: (id: string) => invitationApi.getInvitation(id),
  create: (data: IInvitationRequest) => invitationApi.createInvitation(data),

  // ITL-2545 PIN flow — hand-rolled because the generated SDK has no method for these
  // endpoints (and `InvitationUserRequest` cannot carry the verified `token`). They hit the
  // unauthenticated public boundary, so they use `unauthenticatedSessionInstance` against
  // `configVars.api_url` (= server_url + "/v2"). The shared response interceptor
  // (src/api/instance.ts:13) returns `response.data`, so the awaited value is the JSON body;
  // the `post<unknown, R>` second generic types that body directly (single unwrap — read
  // body.data / body.token, never response.data.data).
  requestOtp: (id: string): Promise<{ data: IInvitation }> =>
    unauthenticatedSessionInstance.post<unknown, { data: IInvitation }>(
      `${configVars.api_url}/invitations/${id}/otp`
    ),
  verifyOtp: (id: string, otp: string): Promise<{ data: IInvitation; token: string }> =>
    unauthenticatedSessionInstance.post<unknown, { data: IInvitation; token: string }>(
      `${configVars.api_url}/invitations/${id}/otp/verify`,
      { otp }
    ),
  createUserWithToken: (id: string, password: string, token: string): Promise<{ data: User }> =>
    unauthenticatedSessionInstance.post<unknown, { data: User }>(
      `${configVars.api_url}/invitations/${id}/users`,
      { password, token }
    )
};

export default api;
